export default {"src":"/_next/static/media/flash-logo-header.035cafcc.svg","height":283,"width":800,"blurWidth":0,"blurHeight":0};